module.exports = __webpack_public_path__ + "img/lens-150-plus-04.15764eb5.png";